import { render, staticRenderFns } from "./ConfirmUpload.vue?vue&type=template&id=d3ff5752&scoped=true&lang=pug&"
import script from "./ConfirmUpload.vue?vue&type=script&lang=js&"
export * from "./ConfirmUpload.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmUpload.vue?vue&type=style&index=0&id=d3ff5752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ff5752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3ff5752')) {
      api.createRecord('d3ff5752', component.options)
    } else {
      api.reload('d3ff5752', component.options)
    }
    module.hot.accept("./ConfirmUpload.vue?vue&type=template&id=d3ff5752&scoped=true&lang=pug&", function () {
      api.rerender('d3ff5752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/older_adult/ConfirmUpload.vue"
export default component.exports